import { render } from "./SettingsHotKeyColors.vue?vue&type=template&id=455003dd"
import script from "./SettingsHotKeyColors.vue?vue&type=script&lang=js"
export * from "./SettingsHotKeyColors.vue?vue&type=script&lang=js"

import "./SettingsHotKeyColors.vue?vue&type=style&index=0&id=455003dd&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__